import { render } from "./Chatroom.vue.js?vue&type=template&id=4ed6b10c&scoped=true!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./Chatroom.vue?vue&type=template&id=4ed6b10c&scoped=true"
import script from "./Chatroom.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./Chatroom.vue?vue&type=script&lang=js"
export * from "./Chatroom.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./Chatroom.vue?vue&type=script&lang=js"

import "./Chatroom.vue.scss?vue&type=style&index=0&id=4ed6b10c&lang=scss&scoped=true!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./Chatroom.vue?vue&type=style&index=0&id=4ed6b10c&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ed6b10c"],['__file',"src/SharedWeb/scripts/components/community/chatrooms/slack-style/Chatroom.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4ed6b10c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4ed6b10c', __exports__)) {
    api.reload('4ed6b10c', __exports__)
  }
  
  module.hot.accept("./Chatroom.vue.js?vue&type=template&id=4ed6b10c&scoped=true!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./Chatroom.vue?vue&type=template&id=4ed6b10c&scoped=true", () => {
    api.rerender('4ed6b10c', render)
  })

}


export default __exports__